import wrapURL from './intercepter';

const fileBackendService = wrapURL(process.env.VUE_APP_ENV === 'production' 
  ? 'https://api.vibrant-wellness.com/v1/ehr/file'
  : 'https://www.vibrant-america.com/lisapi/v1/ehr/file-staging');

export default fileBackendService;